<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Hub InScan(INTransit)</strong>           
          </div>
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>



               <b-col md="4">
                  <b-col sm="12" >
                   <b-form-group label="Rack Id"  :label-cols="4" >
                    <b-form-select  v-model="customer.id"
                     name="rackid" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.rackid') }">
               
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.id" v-for="customer in rackList" :key="customer.id" >{{ customer.id}}</option>
                    </b-form-select> 
                    <span v-show="errors.has('form-1.rackid')" class="help text-danger">{{ errors.first('form-1.rackid') }}</span>
                  </b-form-group>
                </b-col>
                </b-col>

                <b-col md="4">
               <b-form-group label="Shipping Id"  :label-cols="4" >
                 
                <vue-tags-input
                v-model="customer.shippingid" 
                :tags="tags"
                 @tags-changed="newTags => tags = newTags  "
                  :avoidAddingDuplicates="avoidAddingDuplicates"
                 :placeholder="placeholder"
                  ref="taginput"
                 v-bind:separators="[',', ';']"
                   />
                   <span class="badge badge-success1">&nbsp;</span>&nbsp;
                   <label :label-cols="4" >Unique Shipping Id</label><br>
                   <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                 
  
                   <!--  <b-form-input  type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.shipmentid') } " placeholder="Enter Shipment Id " v-on:change="checkExist">
                    </b-form-input>  -->
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                  </b-form-group> 
                </b-col>
                
                <b-col md="4">
                 <b-button    class="mr-4" type="submit" size="md" variant="primary">Hub InScan</b-button>
                 <b-button  @click="clear" size="md" variant="danger">Clear</b-button>
                </b-col>
              </b-row>
           
            </form>
          </div>
            <div slot="footer" v-if ="this.invalidshipppingid"  >
              <b-row>
                <b-col md="12">
                <span>
                  <h6>Invalid Shipmemnts : <strong> {{invalidshipppingid}}</strong></h6> 
                </span>
                </b-col> 
              </b-row>
                
             
               
                      
          </div>
          
        <!--   <b-modal v-if ="this.tags.length > 0" title="Confirmation Box" v-model="toggleInfo" size="sm" @ok="toggleInfoModal = false">
            <template slot="modal-header" slot-scope="{ close }">
            <h5>Reallocate Shipment</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form v-on:submit.prevent="toggleInfoModal(value)">
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">                          
                    <span> Are you sure to reallocate shipment ?</span>
                  </section>
                  <footer slot="modal-footer">
                    <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                  </footer>
                </div>
              </form>
            </template>
            <footer slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="closemodal">
                Cancel
              </b-button>
            </footer>
          </b-modal> -->
        </b-card>  
      </b-col>   
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function() {
    return {
      name: 'allocation',
      data: [],
      DAPendingStatus: [],
      customer: {},
      // toggleInfo: false,
      avoidAddingDuplicates:false,
      placeholder:"Add shippingid",
      data1:'',
      selected:'',
      shippingid: '',
      invalidshipppingid:'',
      tags: [],
      rackList:[],
      disabled: '',
      selectedusertype:0,
      value:'',
      }
  },
  created: function() {
    this.displayRacklist()
  },
  computed: {
  serveur() { 
    // alert('ss');
    return this.customer.deliveryagentmasterid; },
  code() { 
    // alert('cc');
    return this.customer.usertype; }
},
  methods: {
     displayRacklist: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
     // let rackurl = 'http://3.7.22.114/ConsignmentMaster/getracklistbyhub'
      let customerGetobj = {
  
           hub_id:`${userInfo.pickuplocationmasterid}`,
            rack_type:"0"

      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getracklistbyhub`, customerGetobj)
        .then((result) => {
          console.log("Result",result);
           if(result.body.returnmsg === 'Successful') {
          this.rackList = result.body.returnvalue
        }else{
            this.rackList=[];
        }
          // this.data1.sort(this.GetSortOrder('rack'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
 
      
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.toggleInfoModal();
          // this.toggleInfo = !this.toggleInfo
        }
      })
    },
    focusInput() 
    {
      // alert(usertype);
      // this.selectedusertype=usertype;
        this.$refs.taginput.$refs.newTagInput.focus()
        this.disabled=1;
    },
    
   toggleInfoModal: function () {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       var shipmentid=[];
       for(var i = 0; i < this.tags.length; i++) {
          shipmentid.push(this.tags[i].text);  
       }
      const shipmentobj={
         hub_id:`${userInfo.pickuplocationmasterid}`,
         hubexecutiveid:`${userInfo.sysusermasterid}`,
         scantype:"inscan",
         latlong:`${userInfo.pickuplonglat}`,
         rackId:this.customer.id,
         shippingid:shipmentid,
      }
      console.log("test",shipmentobj);
      // return false
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/hubInscanShipmentForCms`, shipmentobj)
        .then((result) => {
            console.log("result",result);
             this.invalidshipppingid=result.body.invalid_shipment;
          if (result.body.returnmsg == 'Successful') {
            
             if(result.body.returnvalue == 'This Shipment is already Scanned'){
               Utils.notify(result.body.returnvalue,'error');
            this.customer = {}
            this.tags=[];
           
          }else{
            Utils.notify(result.body.returnvalue)
            this.customer = {}
            this.tags=[];
          }
          } else {
          
            Utils.notify(result.body.returnvalue,'error')
           

          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      // this.toggleInfo = !this.toggleInfo
    },
    closemodal: function () {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo
    },
    clear: function () {
      this.tags=[];
      this.customer = {}
      this.invalidshipppingid="";
      // this.errors.clear('form-1')
    },
     GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },


  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>
<style >
  .badge-success1
  {
  background-color: #5C6BC0;
    color: #fff;
  }
.badge-success2
  {
  background-color:  #e54d42;
    color: #fff;
  }


</style>

